export function getYouTubeVideoId(url: string): string | null {
  const regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

export function getYouTubeThumbnail(videoId: string, quality: 'default' | 'medium' | 'high' | 'maxres' = 'maxres'): string {
  // Use regular YouTube thumbnail URL - privacy is handled via referrer policy and crossorigin
  return `https://img.youtube.com/vi/${videoId}/${quality}default.jpg`;
}

export function getYouTubeEmbedUrl(videoId: string): string {
  // Use youtube-nocookie.com for privacy-enhanced embedding without third-party cookies
  return `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&controls=1`;
}